<template>
  <v-app-bar
    app
    clipped-left
    fixed
    elevate-on-scroll
  >
    <v-app-bar-nav-icon @click.stop="$emit('update:drawer', !drawer);"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $t('Moje sterowniki') }}</v-toolbar-title>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="primary"
    ></v-progress-linear>
    <div class="flex-grow-1"></div>
    <bell></bell>
    <v-btn icon :loading="loading" :disabled="loading" @click="refresh">
      <v-icon>mdi-cached</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import Bell from './../components/Bell.vue'
import { mapActions } from 'vuex'
export default {
  data: () => ({
    drawer: null,
  }),
  computed: {
    loading() {
      return this.$store.state.controllers.controllersLoading
    }
  },
  methods: {
    ...mapActions([
      'syncControllers'
    ]),
    refresh() {
      this.syncControllers(true)
      .then(res => {
        console.log('refresh z top');
      });
    }
  },
  components: {
    Bell
  }
}
</script>

<style>

</style>